// extracted by mini-css-extract-plugin
export default {"cont":"APILogs_cont__hIzSs","title":"APILogs_title__A-M4I"};